import './style.scss';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { PagePath } from 'constants/pagePath';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { IconName, findIcon } from 'utils/handleIcon';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { useNavigate } from 'react-router-dom';
import {
  InputMaybe,
  SymbolDetailInfo,
  ApplySymbolMutation,
  ApplySymbolResult,
  OverseasRealEstateSymbolDetailInfo,
} from 'views/utils/graphql/graphql';
import { FormikProps } from 'formik';

import { DateFormatType, formatDate, formatPrice } from 'views/utils/converter';

export const OverseasRealEstateSymbolApplyComplete = () => {
  useCustomLocationName('案件申込完了');
  const navigate = useNavigate();

  return (
    <>
      <div className="overseasRealEstate_requestComplete">
        <div className="overseasRealEstate_requestComplete_description">
          <Description
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
            label="出資をお申込みいただきありがとうございます。"
          />
        </div>
        <div className="overseasRealEstate_requestComplete_subDescription">
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
            label="弊社にてお申込み内容を確認後、お届けいただいたメールアドレスあてに"
          />
          <Description
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
            label="5営業日を目処に審査結果についてご連絡差し上げます。"
          />
        </div>
        <div className="overseasRealEstate_requestComplete_buttons">
          <Button
            label="申込履歴を見る"
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            onClick={() => navigate(PagePath.RequestHistory)}
          />
          <Button
            label="HOMEに戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.medium}
            onClick={() => navigate(PagePath.Home)}
          />
        </div>
      </div>
    </>
  );
};
